import { Component, Input } from '@angular/core';
import { ActionsService } from '@modules/search/services/actions.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-copy-content',
  standalone: true,
  imports: [
    TooltipModule
  ],
  templateUrl: './copy-content.component.html',
  styleUrl: './copy-content.component.scss'
})
export class CopyContentComponent {

  @Input() content!: any;
  @Input() title!: string;
  @Input() tooltipPosition!: string;
  @Input() size!: string;
  timer: any;

  isCopied: boolean = false;

  constructor(
    private _action : ActionsService
  ) {}

  handleClick() {
    this.isCopied = !this.isCopied;

    this._action.copyToClipboard(this.removeHtmlTags(this.content));

    this.timer = setTimeout(()=>{
      this.isCopied = !this.isCopied;
    }, 800)
  }

  removeHtmlTags(text: string) {
    return text.replace(/<[^>]*>/g, '');
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
  }
}
